<div class="stitch-checkout-page py-4">
  <div class="container-fluid px-lg-5">
    
    <!-- Stepper Header -->
    <div class="cart-stepper-header mb-4">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h1 class="page-title m-0"><i class="fas fa-credit-card me-2 text-primary"></i>Finalizar Compra Segura</h1>
        <a routerLink="/cart" class="btn-continue-shopping text-decoration-none">
          <i class="fas fa-shopping-cart me-1"></i>Volver al Carrito
        </a>
      </div>

      <!-- Process Stepper -->
      <div class="stitch-checkout-stepper d-flex justify-content-center align-items-center py-3">
        <div class="step-item active">
          <span class="step-num"><i class="fas fa-check"></i></span>
          <span class="step-text">Mi Carrito</span>
        </div>
        <div class="step-line active"></div>
        <div class="step-item active">
          <span class="step-num">2</span>
          <span class="step-text">Dirección & Cotización</span>
        </div>
        <div class="step-line" [class.active]="hasCalculatedShipping"></div>
        <div class="step-item" [class.active]="hasCalculatedShipping">
          <span class="step-num">3</span>
          <span class="step-text">Pago & Confirmación</span>
        </div>
      </div>
    </div>

    <!-- Layout Grilla (Main Form + Summary Sidebar) -->
    <div class="row g-4" *ngIf="cartItems.length > 0; else emptyCart">
      
      <!-- Columna Principal: Formularios de Envío y Pago -->
      <div class="col-lg-8">
        
        <!-- PASO 1: Información del Comprador & Dirección de Entrega -->
        <div class="stitch-card shadow-sm rounded-4 bg-white p-4 mb-4">
          <div class="d-flex align-items-center gap-3 border-bottom pb-3 mb-4">
            <span class="badge-step-num">1</span>
            <div>
              <h4 class="fw-bold m-0 text-dark">Información del Comprador & Dirección de Entrega</h4>
              <span class="small text-muted">Ingresa el destino exacto para consultar las tarifas oficiales de transporte en tiempo real</span>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label font-weight-bold">Nombre Completo *</label>
              <input type="text" class="stitch-form-input" placeholder="Ej. Juan Pérez" [(ngModel)]="buyer.fullName" />
            </div>

            <div class="col-md-6">
              <label class="form-label font-weight-bold">Correo Electrónico *</label>
              <input type="email" class="stitch-form-input" placeholder="ejemplo@correo.com" [(ngModel)]="buyer.email" />
            </div>

            <div class="col-md-6">
              <label class="form-label font-weight-bold">Teléfono / Celular *</label>
              <input type="tel" class="stitch-form-input" placeholder="Ej. 3001234567" [(ngModel)]="buyer.phone" />
            </div>

            <div class="col-md-6">
              <label class="form-label font-weight-bold">Cédula / Documento (Opcional)</label>
              <input type="text" class="stitch-form-input" placeholder="Ej. 1018234567" [(ngModel)]="buyer.documentId" />
            </div>

            <div class="col-md-6">
              <label class="form-label font-weight-bold">Departamento de Destino *</label>
              <select class="stitch-form-select" [(ngModel)]="buyer.department" (change)="onDepartmentChange()">
                <option *ngFor="let dep of departments" [value]="dep">{{ dep }}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label font-weight-bold">Ciudad / Municipio de Destino *</label>
              <select class="stitch-form-select" [(ngModel)]="buyer.city" (change)="onCityChange()">
                <option *ngFor="let c of availableCities" [value]="c">{{ c }}</option>
              </select>
            </div>

            <div class="col-md-8">
              <label class="form-label font-weight-bold">Dirección Exacta de Entrega *</label>
              <input type="text" class="stitch-form-input" placeholder="Ej. Cra 15 # 93-45 Apt 301" [(ngModel)]="buyer.address" />
            </div>

            <div class="col-md-4">
              <label class="form-label font-weight-bold">Barrio / Sector</label>
              <input type="text" class="stitch-form-input" placeholder="Ej. Chicó / El Poblado" [(ngModel)]="buyer.neighborhood" />
            </div>

            <div class="col-12">
              <label class="form-label font-weight-bold">Notas de Entrega (Opcional)</label>
              <input type="text" class="stitch-form-input" placeholder="Ej. Dejar con el portero en recepción..." [(ngModel)]="buyer.notes" />
            </div>

            <!-- Botón Obligatorio: Confirmar Dirección & Cotizar Envío Real con API -->
            <div class="col-12 mt-4 text-end">
              <button class="btn-stitch-primary px-4 py-3 rounded-3" (click)="calculateShippingQuote()" [disabled]="loadingShipping">
                <i class="fas" [ngClass]="loadingShipping ? 'fa-spinner fa-spin me-2' : 'fa-calculator me-2'"></i>
                {{ loadingShipping ? 'Consultando API de Transporte...' : 'Guardar Dirección & Cotizar Envío en Tiempo Real' }}
              </button>
            </div>
          </div>
        </div>

        <!-- PASO 2: Opciones de Envío & Transportadoras (API POST /shipping/quote) -->
        <div class="stitch-card shadow-sm rounded-4 bg-white p-4 mb-4" *ngIf="hasCalculatedShipping || loadingShipping">
          <div class="d-flex align-items-center gap-3 border-bottom pb-3 mb-3">
            <span class="badge-step-num">2</span>
            <div>
              <h4 class="fw-bold m-0 text-dark">Opciones de Envío Cotizadas con la API</h4>
              <span class="small text-muted">Tarifas reales de la API backend para {{ buyer.city }} ({{ buyer.department }})</span>
            </div>
          </div>

          <div *ngIf="loadingShipping" class="text-center py-4">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="small text-muted mt-2">Consultando las mejores tarifas con Coordinadora, Servientrega e Interrapidísimo...</p>
          </div>

          <div *ngIf="!loadingShipping && shippingOptions.length === 0" class="alert alert-warning">
            No se encontraron tarifas automáticas para la ubicación seleccionada. Se aplicará la tarifa estándar nacional.
          </div>

          <div *ngIf="!loadingShipping && shippingOptions.length > 0" class="carrier-options-grid d-flex flex-column gap-3">
            <div 
              *ngFor="let option of shippingOptions" 
              class="carrier-option-card d-flex align-items-center justify-content-between p-3 rounded-3 border cursor-pointer"
              [class.selected]="selectedShipping === option"
              (click)="selectShipping(option)"
            >
              <div class="d-flex align-items-center gap-3">
                <input type="radio" name="shippingCarrier" [checked]="selectedShipping === option" class="form-check-input mt-0" />
                <div>
                  <h6 class="fw-bold m-0 text-dark">{{ option.carrier }}</h6>
                  <span class="small text-muted"><i class="far fa-clock me-1"></i>{{ option.estimatedDeliveryDays }} días hábiles de entrega</span>
                </div>
              </div>

              <div class="text-end">
                <span class="fw-bold fs-5 text-primary">
                  {{ option.totalShippingCost === 0 ? '¡GRATIS!' : ('$' + (option.totalShippingCost | number) + ' COP') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- PASO 3: Selección de Método de Pago -->
        <div class="stitch-card shadow-sm rounded-4 bg-white p-4 mb-4" *ngIf="hasCalculatedShipping">
          <div class="d-flex align-items-center gap-3 border-bottom pb-3 mb-4">
            <span class="badge-step-num">3</span>
            <h4 class="fw-bold m-0 text-dark">Método de Pago Preferido</h4>
          </div>

          <div class="payment-selector-grid d-flex flex-column gap-3">
            <!-- Pago Online Mercado Pago -->
            <div 
              class="payment-box-card d-flex align-items-center justify-content-between p-3 rounded-3 border cursor-pointer"
              [class.selected]="paymentMethod === 'online'"
              (click)="onPaymentMethodChange('online')"
            >
              <div class="d-flex align-items-center gap-3">
                <input type="radio" name="paymentOption" [checked]="paymentMethod === 'online'" class="form-check-input mt-0" />
                <div>
                  <h5 class="fw-bold m-0 text-dark"><i class="fas fa-credit-card me-2 text-primary"></i>Mercado Pago (PSE, Tarjetas, Nequi, Daviplata)</h5>
                  <span class="small text-muted">Cifrado de alta seguridad. Aprobación inmediata de tu orden.</span>
                </div>
              </div>
              <div class="payment-logos d-none d-sm-block">
                <span class="badge bg-light text-dark border me-1">PSE</span>
                <span class="badge bg-light text-dark border">Nequi</span>
              </div>
            </div>

            <!-- Pago Contra Entrega COD -->
            <div 
              class="payment-box-card d-flex align-items-center justify-content-between p-3 rounded-3 border cursor-pointer"
              [class.selected]="paymentMethod === 'cod'"
              (click)="onPaymentMethodChange('cod')"
            >
              <div class="d-flex align-items-center gap-3">
                <input type="radio" name="paymentOption" [checked]="paymentMethod === 'cod'" class="form-check-input mt-0" />
                <div>
                  <h5 class="fw-bold m-0 text-dark"><i class="fas fa-hand-holding-usd me-2 text-success"></i>Pago Contra Entrega (Efectivo / Transferencia al recibir)</h5>
                  <span class="small text-muted">Pagas el valor total a la transportadora únicamente cuando tengas el producto en tus manos.</span>
                </div>
              </div>
              <span class="badge bg-success text-white font-weight-bold">100% Seguro</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Columna Derecha: Resumen de Pedido & Confirmación -->
      <div class="col-lg-4">
        <div class="stitch-card shadow-sm rounded-4 bg-white p-4 sticky-top" style="top: 100px;">
          <h4 class="fw-bold mb-3 border-bottom pb-2">Resumen de la Orden</h4>

          <!-- Items Preview -->
          <div class="checkout-items-scroll mb-3">
            <div *ngFor="let item of cartItems" class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
              <img [src]="resolveImg(item.product?.imageUrl || item.product?.image)" [alt]="item.product?.name" class="checkout-thumb rounded" />
              <div class="flex-grow-1 px-2">
                <h6 class="m-0 font-weight-bold small text-dark">{{ item.product?.name }}</h6>
                <span class="small text-muted">Cant: {{ item.quantity }} <span *ngIf="item.size">| Talla: {{ item.size }}</span></span>
              </div>
              <span class="fw-bold small text-dark">${{ (item.product?.price * item.quantity) | number }}</span>
            </div>
          </div>

          <!-- Desglose Final -->
          <div class="checkout-totals-breakdown d-flex flex-column gap-2 mb-4">
            <div class="d-flex justify-content-between text-muted">
              <span>Subtotal Productos:</span>
              <span>${{ getSubtotal() | number }} COP</span>
            </div>

            <div *ngIf="discountInfo.amount > 0" class="d-flex justify-content-between text-success font-weight-bold">
              <span>Descuento (Cupón {{ discountInfo.couponCode }}):</span>
              <span>-${{ discountInfo.amount | number }} COP</span>
            </div>

            <div class="d-flex justify-content-between text-muted">
              <span>Envío ({{ selectedShipping?.carrier || 'Pendiente' }}):</span>
              <span class="fw-bold text-dark">
                {{ !hasCalculatedShipping ? 'Cotizar arriba' : (getShippingCost() === 0 ? '¡GRATIS!' : ('$' + (getShippingCost() | number) + ' COP')) }}
              </span>
            </div>

            <hr class="my-2" />

            <div class="d-flex justify-content-between align-items-center">
              <span class="fw-bold fs-5 text-dark">TOTAL FINAL:</span>
              <span class="fw-bold fs-4 text-primary">${{ getTotal() | number }} COP</span>
            </div>
          </div>

          <!-- Botón de Acción Final -->
          <button 
            class="btn-stitch-checkout w-100 py-3 rounded-3" 
            (click)="processOrder()" 
            [disabled]="loading || !hasCalculatedShipping || !selectedShipping"
          >
            <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin me-2' : (paymentMethod === 'online' ? 'fa-lock me-2' : 'fa-check-circle me-2')"></i>
            {{ loading ? 'Procesando Pedido...' : (paymentMethod === 'online' ? 'Pagar con Mercado Pago' : 'Confirmar Pedido Contra Entrega') }}
          </button>
          
          <p *ngIf="!hasCalculatedShipping" class="small text-muted text-center mt-2">
            <i class="fas fa-info-circle me-1"></i>Ingresa tu dirección y haz clic en "Cotizar Envío" para activar el botón de compra.
          </p>
        </div>
      </div>

    </div>

    <!-- Template Carrito Vacío -->
    <ng-template #emptyCart>
      <div class="empty-cart-card text-center py-5 shadow-sm rounded-4 bg-white">
        <i class="fas fa-shopping-cart fa-3x text-muted mb-3"></i>
        <h3>No tienes ítems en el carrito</h3>
        <p class="text-muted mb-4">Agrega productos al carrito antes de finalizar la compra.</p>
        <a routerLink="/shop" class="btn-stitch-hero-action text-decoration-none">Ver Catálogo</a>
      </div>
    </ng-template>

  </div>
</div>